import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Mot de passe admin depuis les variables d'environnement
  const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'meya2026';

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Vérifier d'abord si un mot de passe personnalisé existe
    const customPassword = localStorage.getItem('meya_admin_custom_password');
    const passwordToCheck = customPassword || ADMIN_PASSWORD;

    // Simuler une vérification
    setTimeout(() => {
      if (password === passwordToCheck) {
        // Stocker la session dans localStorage
        localStorage.setItem('meya_admin_auth', 'true');
        localStorage.setItem('meya_admin_login_time', Date.now().toString());
        toast.success('Connexion réussie !');
        navigate('/admin/dashboard');
      } else {
        toast.error('Mot de passe incorrect');
        setPassword('');
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <div className="admin-login-icon">
              <Lock size={48} />
            </div>
            <h1>Espace Administrateur</h1>
            <p>Meya Beauté & Tradition</p>
          </div>

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Mot de passe
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                  placeholder="Entrez le mot de passe admin"
                  required
                  disabled={loading}
                  autoComplete="off"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn-admin-login"
              disabled={loading || !password}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
